import L, {Icon} from 'leaflet'

const statusIcon = (status) => {
    return L.divIcon({
        className: '',
        html: `
            <div class="ring-container-${status}">
                <span class="circle-${status}"></span>
                <span class="ringring-${status}"></span>
            </div>
        `,
        iconSize: [38, 38],
    });
};

export const StatusSignal = ({status}) => {
    return (
        <div className={`ring-container-${status}`}>
            <div className={`circle-${status}`}></div>
            <div className={`ringring-${status}`}></div>
        </div>
    );
}

export const statusImages = {
    'active' : statusIcon('active'),
    'dim' : statusIcon('dim'),
    'error': statusIcon('error'),
    'off': statusIcon('off'),
    'selected' : statusIcon('selected'),
    'deverror': statusIcon('deverror'),
    'light' : statusIcon('light'),
    'excellent' : statusIcon('excellent'),
    'good' : statusIcon('good'),
    'medium' : statusIcon('medium'),
    'bad' : statusIcon('bad'),
    'open' : statusIcon('open'),
    'close' : statusIcon('close'),
    'join' : statusIcon('join'),
    'device' : statusIcon('device'),
    'gateway' : new Icon({
        iconUrl : require('../components/DataMap/assets/gatewayicon.png'),
        iconSize: [38,38]
    }),
}

export const deviceStatusMapper = {
    'active': "Πλήρης Λειτουργία",
    'dim': "Διαβαθισμένη Ισχύς",
    'deverror': "Δεν Αποκρίνεται",
    'off': "Σβηστό",
    'selected': "Επιτυχής Σύνδεση στο Διαδίκτυο",
    'error': "Σφάλμα στην συσκευή",
    'light' : "Απλό Φωτιστικό",
    'gateway' : "Είναι Gateway",
    'excellent' : "Άριστη",
    'good' : "Καλή",
    'medium': "Μέτρια",
    'bad' : "Κακή",
    'open' : "Ελεύθερη",
    'close' : "Δεσμευμένη",
    'join' : "Επιτυχής Σύνδεση στο Διαδίκτυο",
}

export const transmissionIcon = L.icon({
    iconUrl : require('../assets/luminaire_selected.png'),
    iconSize: [38,38]
});

export const noTransmissionDefaultIcon = L.icon({
    iconUrl : require('../assets/luminaire_error.png'),
    iconSize: [38,38]
});
